import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../models/api-resource.interface';
import { DesiredFunction } from './desired-function.interface';

export class DesiredFunctionService {
   async getDesiredFunction(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<DesiredFunction>>>(`/desired-functions`, { params: { ...query } });
      return response.data;
   }
}
